import styled from 'styled-components';

export const CompetitionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  padding: 1.05em 0.55em;  
  font-size: 1.2em;
  width: 100%;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    width: auto;
    justify-self: center;
  }
`;

export const CompetitionName = styled.div`
  color: ${props => props.theme.colors.black};
  font-family: ${props => props.theme.fontSets.narrowMedium};
  font-size: 19px;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    font-size: 16px;
  }
`;

export const CompetitionRound = styled.div`
  margin-left: 0.3em;
  display: ${props => ((props.competitionId === '88') || (props.competitionId === '34') || (props.competitionId === '1166')
            || (props.competitionId === '3' && props.isBasket) ? 'none' : '')};
`;

export const CompetitionAllMatch = styled.div`
  cursor: pointer;
  margin-left: auto;
  display: ${props => ((props.competitionId === '88') || (props.competitionId === '34') || (props.competitionId !== '174') || (props.competitionId !== '1166') ? 'none' : '')};
`;

export const TwoPoints = styled.span`
  display: ${props => ((props.competitionId === '88') || (props.competitionId === '34') || (props.competitionId === '1166')
            || (props.competitionId === '3' && props.isBasket) ? 'none' : '')};
`;
